"use strict";

/**
 * @classdesc
 * Abstrakte Basisklasse, für Wrapperklassen.
 *
 * @template T
 *
 * @abstract
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.GCWrappable = function()
{
	gc.gis.GCObservable.call( this );
};
gc.gis.GCWrappable.prototype = Object.create( gc.gis.GCObservable.prototype );

/**
 * Gibt die Instanz der zu wrappenden Klasse zurück.
 *
 * @abstract
 * @method
 * @public
 * @return {T} gewrappte Instanz
 */
gc.gis.GCWrappable.prototype.getImpl = gc.gis.abstractMethod;

